export default "__VITE_ASSET__Ezulp1nm__"